<template>
  <div class="table-container mt-2 mb-5">
    <table class="styled-table">
      <thead>
        <tr>
          <th v-for="(section, index) in sections" :key="index">{{ section.titulo }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(section, index) in sections" :key="index">
          <td>
            <ul>
              <li v-for="(contenido, i) in section.contenido" :key="i">
                <div class="contenido-fila">
                  <!-- Mostrar título -->
                  <span class="contenido-titulo">{{ contenido.titulo }}</span>

                  <!-- Contenedor para los íconos -->
                  <div class="iconos-contenedor">
                    <a v-if="contenido.url_pdf" :href="urlServe + contenido.url_pdf" target="_blank">
                      <i class="fas fa-file-pdf icono-archivo icon-pdf"></i>
                    </a>
                    <a v-if="contenido.url_word" :href="urlServe + contenido.url_word" target="_blank">
                      <i class="fas fa-file-word icono-archivo icon-word"></i>
                    </a>
                    <a v-if="contenido.url_excel" :href="urlServe + contenido.url_excel" target="_blank">
                      <i class="fas fa-file-excel icono-archivo icon-excel"></i>
                    </a>
                    <a v-if="contenido.url_comprimido" :href="urlServe + contenido.url_comprimido" target="_blank">
                      <i class="fas fa-file-archive icono-archivo icon-rar"></i>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true
    },
    urlServe: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  font-family: "Raleway", sans-serif;
}
.styled-table thead th {
  background-color: rgba(0, 0, 0, .03)!important;
  color: #621132;
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #621132;
}
.styled-table tbody tr {
  border-bottom: 1px solid #621132;
}
.styled-table tbody td {
  padding: 0.75rem;
  vertical-align: top;
}
.styled-table ul {
  padding-left: 0;
  margin: 0;
}
.styled-table ul li {
  list-style-type: none;
  list-style: none;
  margin-bottom: 1rem;
  border-bottom: 1px solid #cfcfcf;
  padding: 0.2rem 0;
  font-size: 14px;
  transition: ease all .1s;
}
.styled-table ul li:hover {
  transform: scale(1.01);
}
.contenido-fila {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.contenido-titulo {
  flex: 1;
  margin-right: 10px;
  font-size: 1.2rem;
}

.iconos-contenedor {
  display: flex;
  font-size: 1.2rem;
  gap: 5px;
}

.icono-archivo {
  font-size: 2rem;
  /* color: #621132; */
}
.icon-pdf{
    color: #e74c3c!important; 
}
.icon-word {
    color: #007bff!important;
}
.icon-excel {
    color: #28a745!important;
}
.icon-rar {
    color: #f39c12!important;
}
</style>
